<!-- eslint-disable vue/no-mutating-props -->
<template>
<main>

<form v-on:submit.prevent="editForm">

<section>
  <h2>Status</h2>

  <div class="field">
    <div>
      <toggle-button v-model="form.enabled" :sync="true"/>
      <label v-if="form.enabled" for="enabled">Form Enabled</label>
      <label v-else for="enabled">Form Disabled</label>
    </div>
    <p class="help">Enable or disable submission of new entries</p>
  </div>

  <div v-if="!form.enabled" class="notification is-warning">
    <p>A disabled form will not process <strong>(save or send)</strong> any submissions.</p>
    <p>End users will see a notice asking them to submit again at a later date.</p>
  </div>

</section>

<section>
  <h2>Form Details</h2>

  <div class="field">
    <label>Form Name</label>
    <div class="control">
      <input v-model="form.name" type="text" placeholder="Form Name">
      <p class="help">This may be visible to both clients and end users.</p>
    </div>
  </div>

  <div class="field">
    <label>Domain</label>
    <div class="control">
      <input v-model="form.domain" type="text" placeholder="example.org">
      <p class="help">The domain the form will be located at</p>
    </div>
  </div>

  <div class="field">
    <label>Redirect URL</label>
    <div class="control">
      <input v-model="form.redirect" type="text" placeholder="https://example.org/thanks">
      <p class="help">The URL a user will be redirected to after form submission.</p>
      <p class="help">If left blank, a generic 'Thank You' page will be served.</p>
    </div>
  </div>

</section>

<section>
  <h2>Additional AntiSpam</h2>

  <div class="field">
    <div>
      <toggle-button v-model="form.extraSpamCheck" :sync="true"/>
      <label v-if="form.extraSpamCheck">Enabled</label>
      <label v-else>Disabled</label>
    </div>
    <p class="help">Includes testing entries for links, checks IP &amp; email databases, and country blacklists</p>
  </div>

</section>

<section>
  <h2>Attachments</h2>

  <div class="field">
    <div>
      <toggle-button v-model="form.allowFileUploads" :sync="true"/>
      <label v-if="form.allowFileUploads">Allow File Uploads</label>
      <label v-else>Block File Uploads</label>
    </div>
    <p class="help">Currently only images (jpg, png, gif, bmp) are supported</p>
  </div>

</section>

<section>
  <h2>Captcha Keys</h2>

  <p>reCAPTCHA Keys are created <a target="_blank" href="https://www.google.com/recaptcha/admin">here</a>.
  Select <em>Invisible reCAPTCHA</em> & fill in the Domains field.</p>

  <div class="field">
    <label>Site Key</label>
    <div class="control">
      <input v-model="form.captchaSite" type="text">
    </div>
  </div>

  <div class="field">
    <label>Secret Key</label>
    <div class="control">
      <input v-model="form.captchaSecret" type="text">
    </div>
  </div>

</section>

<section>
  <h2>Recipients</h2>

  <div class="field recipients">
    <label>
      Email<br>
      <a class="button" @click="addEmailInput">Add New Email</a>
    </label>
    <div class="control">

    <div v-for="(input, index) in this.emailRecipients" :key="index"
      class="has-addons">
        <input v-model="input.address"
        type="email" placeholder="jane.doe@example.org">
        <a class="addon" @click="deleteEmailInput(index)">Remove</a>
    </div>
    </div>
  </div>

</section>

  <div v-if="error" class="message is-danger">
    <div class="message-header">Error creating form:</div>
    <div class="message-body"><p>{{error}}</p></div>
  </div>

<button class="edit button is-large is-info is-fullwidth">Save Form</button>

</form>

</main>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import FormsService from '@/services/Forms';

export default {
  props: ['form'],
  data() {
    return {
      error: '',
      what: null,
    };
  },
  computed: {
    emailRecipients() {
      return this.form.recipients.filter((r) => r.type === 'email');
    },
  },
  watch: {
  },
  methods: {
    deleteEmailInput(index) {
      this.form.recipients.splice(index, 1);
    },
    addEmailInput() {
      this.form.recipients.push({ type: 'email', address: '' });
    },
    editForm() {
      const form = {
        id: this.form.id,
        enabled: this.form.enabled,
        name: this.form.name,
        domain: this.form.domain,
        redirect: this.form.redirect,
        allowFileUploads: this.form.allowFileUploads,
        captchaSite: this.form.captchaSite,
        captchaSecret: this.form.captchaSecret,
        recipients: this.form.recipients,
        extraSpamCheck: this.form.extraSpamCheck,
      };

      FormsService.editForm(form).then((response) => {
        if (response.status === 200) {
          this.$emit('updated', response.data);
        } else this.error = response.data.error;
      }).catch((e) => { this.error = e.response.data.error; });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  section {
    padding-bottom: 2em;
  }

  section h2 {
    font-size: 120%;
    font-weight: 300;
    text-transform: uppercase;
    border-bottom: 1px solid black;
    margin-bottom: 1em;
  }

  form .create { margin-bottom: 2em; }

  form .field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5em;
    padding: 1em;
    border-radius: 5px;
    background: white;
  }

  form .control  {
    width: 70%;
  }

  form label {
    font-weight: bold;
    padding-left: 0.5em;
  }

  form input {
    border: none;
    padding: 0.75em;
    width: 100%;
    background: lightgray;
  }

  form .field.recipients label .button {
    background: var(--green);
    font-weight: normal;
    margin: 15px 0;
    display: block;
    padding: 0.5em;
    cursor: pointer;
  }

  form .field.recipients input {
    width: 80%;
    margin-bottom: 5px;
  }

  form .field.recipients .addon {
    width: 20%;
    background: var(--red);
    padding: 0.70em;
    cursor: pointer;
  }

  form .help {
    font-size: 80%;
    margin: 0;
    padding: 5px 0;
  }

  .notification.is-warning {
    background: var(--yellow);
    padding: 1em;
    border-radius: 5px;
  }

  form button.edit {
    width: 100%;
    padding: 1em;
  }

</style>
